import { useContext } from 'react';

import { GeoLocationContext } from '../../contexts/geoLocationContext';

export function useGeoLocation() {
  const context = useContext(GeoLocationContext);

  const { longitude, latitude, handleGetCurrentGeoLocation } = context;

  return {
    longitude,
    latitude,
    handleGetCurrentGeoLocation,
  };
}
